const isObjectRecord = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
const hasSegmentExternalIdsProperty = (value) => {
    if (!isObjectRecord(value)) {
        return false;
    }
    const externalIds = Object.entries(value).find(([key]) => key === "externalIds")?.[1];
    return (Array.isArray(externalIds) &&
        externalIds.length > 0 &&
        externalIds.every(isSegmentExternalIdLike));
};
const isSegmentExternalIdLike = (value) => {
    if (!isObjectRecord(value)) {
        return false;
    }
    return (typeof value.id === "string" &&
        typeof value.type === "string" &&
        value.collection === "users" &&
        value.encoding === "none");
};
export const assertNoSegmentExternalIdsInValueArgument = ({ argument, commandName, valueArgumentName, callShape, }) => {
    if (!hasSegmentExternalIdsProperty(argument)) {
        return;
    }
    throw new Error(`${commandName} received externalIds in the ${valueArgumentName} argument. Use ${callShape} instead.`);
};
